export const Email = {
  SUPPORT: 'support@pullrequest.com',
  SALES: 'sales@pullrequest.com',
  ACCOUNTS: 'accounts@pullrequest.com',
  HELLO: 'hello@pullrequest.com',
};
